import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useLocation } from 'react-router-dom';
import getContentTermsOfUse from '@kfc-global/react-shared/redux/Actions/TermsOfUseAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getTermsOfUseData, getTernaryValue } from 'common/utilities/utils';
import { getCmsClient } from 'common/utilities/cmsClient';
import {
  TERMS_AND_CONDITIONS_TITLE,
  TERMS_AND_CONDITIONS_URL,
} from 'organisms/CouponsLanding/Constants/CouponConstants';
import { TERMS_OF_USE_CONSTANTS } from 'components/TermsOfUsePage/Constants/TermsOfUseConstants';
import isEmpty from 'lodash/isEmpty';
import { NotFound } from 'components/NotFound/Container/NotFound';
import TermsOfUseContainer from 'organisms/TermsOfUse/Container/TermsOfUseContainer';
import { StructureData } from 'organisms/StructureDataComponent';

const TermsOfUseComponent = props => {
  const termsAndConditionsUrlValue = translateWithI18Next(TERMS_AND_CONDITIONS_TITLE);
  const dispatch = useDispatch();
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    //In order to show title in RN App
    if (location.pathname.includes(TERMS_AND_CONDITIONS_URL) && translateWithI18Next(TERMS_AND_CONDITIONS_TITLE)) {
      document.title = termsAndConditionsUrlValue;
    }
  }, [termsAndConditionsUrlValue, location.pathname]);

  /* to call API dynamically [fields.page : 'Terms and Conditions' or 'Terms of Use' ] */

  const filedsPageValue = getTernaryValue(
    location.pathname.includes(TERMS_OF_USE_CONSTANTS.TERMS_OF_USE_URL),
    TERMS_OF_USE_CONSTANTS.TERMS_OF_USE_TEXT,
    TERMS_OF_USE_CONSTANTS.TERMS_AND_CONDITIONS_TEXT,
  );

  const TermsOfUse = location.pathname.includes(TERMS_OF_USE_CONSTANTS.TERMS_OF_USE_URL);
  const allReducerData = useSelector(data => ({
    termsOfUseContent: data?.termsOfUseReducer?.response,
  }));

  useEffect(() => {
    dispatch(
      getContentTermsOfUse({
        object: getCmsClient(),
        contentFull: {
          content_type: 'staticLandingPage',
          'fields.page': filedsPageValue,
          include: '5',
        },
      }),
    );
  }, [dispatch, filedsPageValue, location.pathname]);

  const termsOfUseContentStr = JSON.stringify(allReducerData?.termsOfUseContent);
  const [tnsContent, setTnsContent] = useState(null);

  useEffect(() => {
    const segmentedTermsOfUse = getTermsOfUseData(
      allReducerData?.termsOfUseContent?.termsResponseData?.items?.[0]?.fields,
    );
    setTnsContent(segmentedTermsOfUse);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [termsOfUseContentStr]);

  return (
    <>
      {TermsOfUse && <Route component={NotFound} />}
      {!TermsOfUse && !isEmpty(tnsContent) && (
        <>
          {tnsContent.seoTemplate && <StructureData seoTemplate={tnsContent.seoTemplate} />}
          <TermsOfUseContainer contentData={tnsContent} userParams={userParams} />
        </>
      )}
    </>
  );
};

export default TermsOfUseComponent;
